import {Forgot} from "../Forgot/Forgot"

export const ForgotPage =()=>{
    return (
        <>
            <Forgot/>
        </>
    )
}